import { ZonesState } from "./types";

export const zonesDomain = "zones" as const;

export const zonesInitialState: ZonesState = {
  zones: [],
  activeZoneIds: [],
  isDeleteZoneModalOpen: false,
};
